import { render, staticRenderFns } from "./myStory.vue?vue&type=template&id=5bfafda8&scoped=true&"
import script from "./myStory.vue?vue&type=script&lang=js&"
export * from "./myStory.vue?vue&type=script&lang=js&"
import style0 from "./myStory.vue?vue&type=style&index=0&id=5bfafda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfafda8",
  null
  
)

export default component.exports